var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Card",
    [
      _c(
        "Row",
        { attrs: { gutter: 16 } },
        [
          _c("Col", { attrs: { span: "24" } }, [
            _c("div", { staticClass: "global-tool-bar" }, [
              _c("div", { staticClass: "left-bar" }, [
                _c("span", { staticClass: "title" }, [_vm._v("通知公告管理")]),
              ]),
              _c(
                "div",
                { staticClass: "right-bar" },
                [
                  _c(
                    "Button",
                    {
                      staticClass: "btns",
                      attrs: {
                        size: "small",
                        shape: "circle",
                        type: "success",
                        icon: "ios-add-circle-outline",
                      },
                      on: { click: _vm.onNoticeCreate },
                    },
                    [_vm._v("新增")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { title: "通知公告", scrollable: true },
          model: {
            value: _vm.noticeFormShow,
            callback: function ($$v) {
              _vm.noticeFormShow = $$v
            },
            expression: "noticeFormShow",
          },
        },
        [
          _c(
            "Form",
            { attrs: { "label-position": "top" } },
            [
              _c(
                "Row",
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "标题" } },
                    [
                      _c("Input", {
                        attrs: { maxlength: 100 },
                        model: {
                          value: _vm.noticeForm.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.noticeForm, "title", $$v)
                          },
                          expression: "noticeForm.title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "FormItem",
                    { staticClass: "content-top", attrs: { label: "内容" } },
                    [
                      _c("quill-editor", {
                        model: {
                          value: _vm.noticeForm.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.noticeForm, "content", $$v)
                          },
                          expression: "noticeForm.content",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  staticClass: "form-button",
                  attrs: { type: "success" },
                  on: { click: _vm.onSave },
                },
                [_vm._v("保存")]
              ),
              _c(
                "Button",
                {
                  staticClass: "form-button",
                  attrs: { type: "text" },
                  on: { click: _vm.onCancel },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "Col",
            { attrs: { span: "24" } },
            [
              _c("stand-pagination-table", {
                attrs: {
                  columns: _vm.mainTable.columns,
                  data: _vm.mainTable.data,
                  loading: _vm.mainTable.loading,
                  "table-search": _vm.mainTable.tableSearch,
                  "table-load-event": _vm.getNoticeTableRecords,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }